import React, { Fragment } from 'react';
import { Table, Header, Segment, Button, Container, Form, Checkbox, Loader, Popup, Icon } from 'semantic-ui-react';
import { PageHeader } from 'react-bootstrap';
import Modal from 'react-modal';
import moment from 'moment';
import { HeaderCursor } from '../Professor/ProfessorInputGrades/css';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { FiltersOnStyle, IconHeader } from '../Assets/util/css';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;


// TODO emir: add, edit, ... change strings to constants
// TODO emir: where are rows sorted?
// TODO emir: consider if it would be cleaner to devide this in seperate files
// TODO: relocate this custom modal style to a separate file for all inline styles
// cusotm modal style

// TODO: extract to util
const formatForDisplay = (value, type) => {
    switch (type) {
    case 'text':
        return value;
    case 'textarea':
        // TODO: if it exceeds 30chars, crop it and end with ...
        return value;
    case 'number':
        // TODO: hide decimals after 2nd
        return value;
    case 'bool':
        return value ? 'DA' : 'NE';
    case 'timestamp':
        // add error handling
        return moment(value).format('LL');
    default:
        return value;
    }
};

const customModalStyle = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        border: 'none',
        padding: '0'
    }
};

// config prop is injected via HOC lookupSimplerHOC
// TODO: add filter field for searches
// TODO: add pagination and counts per page dropdown
// TODO: add support for boolean/binary types (checkbox)
// TODO: add validation definitions in lookupConfig.js
class LookupSimpler extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            error: false,
            loading: false,
            editMode: false,
            modalMode: null,
            currentEntry: null,

            tableSize: '',
        };
        this._setModalMode = this._setModalMode.bind(this);
        this.handleFormSubmit = this.handleFormSubmit.bind(this);
        this.handleRowSelected = this.handleRowSelected.bind(this);
        this.renderTableSizeButtonGroup = this.renderTableSizeButtonGroup.bind(this);
    }

    componentDidMount() {
        const { url } = this.props.config;
        // retrive data from server
        // TODO muhamed: set this.state.error on catch in axios promise

        // FIXME: every get request needs to have name, pageNumber and resultsPerPage, despite the fact that pagination is not
        // implemented yet on the front-end
        const paginationConfig = {
            name: '',
            pageNumber: 0,
            resultsPerPage: 1000,
        };
        this.setState({ loading: true });
        axios.get(url, { params: paginationConfig })
            .then(res => this.setState({ data: res.data, loading: false }));
    }

    // used to switch between modal modes: if passed null, modal will dissapear
    // modal modes are : null, 'add', 'edit', 'confirmDelete', 'info'
    _setModalMode(mode) {
        if (mode === null) this.setState({ currentEntry: null });
        this.setState({ modalMode: mode });
    }

    // TODO muhaned: catch failed requests and display an error
    handleFormSubmit(newEntry, mode) {
        if (mode === 'add') {
            // append newEntry to state.data and hide modal
            const { data } = this.state;
            const newData = [...data, newEntry];
            this.setState({ data: newData });
            this.setState({ modalMode: null });
        }
        if (mode === 'edit') {
            // find the modified obj by id and replace it, afterwards hide modal
            const { data } = this.state;
            const indexToReplace = data.findIndex((element) => element.id === newEntry.id);
            data[indexToReplace] = newEntry;
            this.setState({ data });
            this.setState({ modalMode: null });
        }
        if (mode === 'confirmDelete') {
            // find the deleted obj, and remove it from state
            const { data } = this.state;
            const newData = [...data].filter(obj => obj.id !== newEntry.id);
            this.setState({ data: [...newData] });
            this.setState({ modalMode: null });
        }
    }

    handleRowSelected(row) {
        // populate the currentEnty object to allow edits and delete
        this.setState({ currentEntry: row });
    }

    // TODO muhamed: add error response if any errors are catched
    renderTableSizeButtonGroup() {
        const { tableSize } = this.state;
        return (
            <Button.Group floated="right">
                <Button icon onClick={() => this.setState({ tableSize: 'small' })} active={tableSize === 'small'}>
                    <i style={{ fontSize: '10px', cursor: 'pointer' }} className="fa fa-font"></i>
                </Button>
                <Button icon onClick={() => this.setState({ tableSize: '' })} active={tableSize === ''}>
                    <i style={{ fontSize: '14px', cursor: 'pointer' }} className="fa fa-font"></i>
                </Button>
                <Button icon onClick={() => this.setState({ tableSize: 'large' })} active={tableSize === 'large'}>
                    <i style={{ fontSize: '18px', cursor: 'pointer' }} className="fa fa-font"></i>
                </Button>
            </Button.Group>
        );
    }

    render() {
        const { config } = this.props;
        const {
            data, loading, currentEntry, modalMode
        } = this.state;
        // if (loading) return <div> Loading...</div>;

        return (
            <div>
                {/* <Header as="h1">Šifrarnici</Header> */}
                {this.state.loading ?
                    <div style={{ paddingTop: '100px', paddingBottom: '100px' }}><Loader active inline="centered" /></div>
                    : <Fragment>

                        <Segment.Group raised>
                            <Segment>
                                <Header as="h3">{config.tableSimpleName}
                                    <Header style={IconHeader} floated="right" >

                                        {(localStorage.getItem('activeRole')
                                            .substr(0, 8) === 'Ministar') ? null : <Button
                                                floated="right"
                                                icon
                                                labelPosition="right"
                                                primary
                                                size="small"
                                                style={FiltersOnStyle}
                                                onClick={() => this.setState({ modalMode: 'add' })}
                                            >
                                                <Icon className="add" />
                                                Dodaj
                                            </Button>}

                                    </Header>

                                </Header>
                            </Segment>

                            {/* modal: null, add, edit, info, confirmDelete */}
                            {modalMode !== null && <Segment >
                                {modalMode === 'add' ?
                                    <LookupSimplerForm
                                        mode="add"
                                        currentEntry={null}
                                        columns={config.columns}
                                        url={config.url}
                                        handleFormSubmit={this.handleFormSubmit}
                                        setModalMode={this._setModalMode}
                                    />
                                    : modalMode === 'edit' ?
                                        <LookupSimplerForm
                                            mode="edit"
                                            currentEntry={currentEntry}
                                            columns={config.columns}
                                            url={config.url}
                                            handleFormSubmit={this.handleFormSubmit}
                                            setModalMode={this._setModalMode}
                                        />
                                        : modalMode === 'info' ?
                                            <LookupSimplerInfo
                                                columns={config.columns}
                                                setModalMode={this._setModalMode}
                                                currentEntry={currentEntry}

                                            />
                                            : modalMode === 'confirmDeletep' ?
                                                <LookupSimplerConfirmDelete
                                                    setModalMode={this._setModalMode}
                                                    currentEntry={currentEntry}
                                                    handleFormSubmit={this.handleFormSubmit}
                                                    url={config.url}

                                                />
                                                : null
                                }
                            </Segment>}

                            <Segment>


                                <LookupSimplerTable
                                    config={config}
                                    data={data}
                                    onRowSelected={this.handleRowSelected}
                                    tableSize={this.state.tableSize}
                                    setModalMode={this._setModalMode}
                                    modalMode={this.state.modalMode}
                                    currentEntry={currentEntry}
                                    handleFormSubmit={this.handleFormSubmit}
                                />
                            </Segment>
                        </Segment.Group>


                    </Fragment>}
            </div>
        );
    }
}

// TODO: add datepicker for DATE types
// props: data ([{},{},...]), currentEntry (obj), columns ([]), url string
class LookupSimplerForm extends React.Component {
    constructor(props) {
        super(props);

        // if edit mode populate state with values from currentEntry
        if (this.props.mode === 'edit') {
            const current = this.props.currentEntry;
            delete current.url; // Remove the buttons property
            this.state = { ...current };
        } else {
            // dynamically create initial state for every column
            const initialState = this.props.columns.filter(e => e.type !== 'buttons').map(columnName => columnName.name)
                .reduce((o, key) => Object.assign(o, { [key]: '' }), {});
            this.state = { ...initialState };
        }

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleCheckBoxChange = this.handleCheckBoxChange.bind(this);
    }
    handleCheckBoxChange(e, { name, checked }) {
        this.setState({ [name]: checked });
    }

    handleChange(event, a) {
        const { target } = event;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const { name } = target;


        this.setState({
            [name]: value
        });
    }
    // TODO muhamed: catch failed additions and edits
    handleSubmit(event) {
        event.preventDefault();
        const formData = this.state;
        const { url, currentEntry } = this.props;
        if (this.props.mode === 'add') {
            axios.post(url, formData)
                .then(res => this.props.handleFormSubmit(res.data, 'add'));
        }

        // if in edit mode append id from current entry to formData
        if (this.props.mode === 'edit') {
            delete formData.translations;
            axios.put(url, { id: currentEntry.id, ...formData })
                .then(res => this.props.handleFormSubmit(res.data, 'edit'));
        }
    }

    render() {
        const { columns, mode } = this.props;
        return (

            <Segment.Group >
                <Segment>
                    <Header as="h3">{mode === 'add' ? 'Dodavanje' : 'Izmijeni'}</Header>
                </Segment>
                <Segment>
                    <Form>
                        {columns.map((column, index) =>
                            (column.type !== 'buttons' && <div className="form-group row" key={index}>
                                <label
                                    className="col-sm-2 col-form-label"
                                    htmlFor={column.name}
                                >
                                    {column.simpleName}
                                </label>
                                <div className="col-sm-10">
                                    {column.type === 'textarea' ?
                                        <textarea
                                            className="form-control"
                                            value={this.state[column.name]}
                                            onChange={this.handleChange}
                                            name={column.name}
                                        />
                                        : column.type === 'bool' ?
                                            <Checkbox
                                                label=""
                                                name={column.name}

                                                onChange={this.handleCheckBoxChange}
                                                checked={this.state[column.name]}
                                            />
                                            : <input
                                                name={column.name}
                                                className="form-control form-control-sm"
                                                type={column.type}
                                                onChange={this.handleChange}
                                                value={this.state[column.name]}
                                            />
                                    }
                                </div>
                            </div>))}


                    </Form>
                </Segment>
                <Segment clearing>
                    {/* hide modals if user presses cancel */}
                    {/* TODO emir: null : null ? */}
                    <Button color="blue" basic="true" onClick={() => this.props.setModalMode(mode === 'add' ? null : null)} floated="right">Odustani</Button>
                    <Button color="blue" type="submit" onClick={this.handleSubmit} floated="right">
                        {mode === 'add' ? 'Dodaj' : 'Prihvati izmjenu'}
                    </Button>
                </Segment>
            </Segment.Group>


        );
    }
}

// TODO: crop descriptions from table rows if the exceed >30 chars
// columnOrder: [] -> used to prevent mapping of manyToMany relations and unnecessary columns like optlock on the table
// props: onRowSelect(id)
class LookupSimplerTable extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
        this.handleClick = this.handleClick.bind(this);
    }

    handleClick(row) {
        this.props.onRowSelected(row);
    }

    render() {
        const { columns, url } = this.props.config;
        const {
            data, tableSize, modalMode, currentEntry, handleFormSubmit
        } = this.props;
        if (data.length > 0) {
            return (
                <Table celled size={tableSize} selectable style={HeaderCursor}>
                    <Table.Header>
                        <Table.Row>
                            {columns.map((el, index) =>
                                <Table.HeaderCell key={index}>{el.simpleName}</Table.HeaderCell>)}
                        </Table.Row>
                    </Table.Header>
                    <Table.Body>

                        {data.map((row, index) => (
                            <LookupSimplerTableRow
                                key={index}
                                row={{ ...row, url }}
                                columnOrder={columns.map(col => ({ name: col.name, type: col.type }))}
                                handleClick={this.handleClick}
                                setModalMode={this.props.setModalMode}
                                modalMode={modalMode}
                                currentEntry={currentEntry}
                                handleFormSubmit={handleFormSubmit}
                            />
                        ))}
                    </Table.Body>
                </Table>
            );
        }
        return <div>Tabela je prazna.</div>;
    }
}

// props: row (obj), handleClick fun, columnOrder ([])
const LookupSimplerTableRow = ({
    row, handleClick, columnOrder, setModalMode, modalMode, currentEntry, handleFormSubmit
}) => (

    <Table.Row >
        {columnOrder.map((col, index) => col.type === 'buttons' ? <td key={100} style={{ textAlign: 'center' }}>
            {modalMode === 'confirmDelete' ?

                row.id === currentEntry.id && <LookupSimplerConfirmDelete
                    setModalMode={setModalMode}
                    currentEntry={currentEntry}
                    handleFormSubmit={handleFormSubmit}
                    url={row.url}

                />
                : <Fragment>
                    <Popup
                        content="Izmijeni podatke"
                        position="top center"
                        trigger={
                            <Button
                                basic="true"
                                color="green"
                                circular
                                icon="pencil"
                                size="small"
                                onClick={() => {
                                    handleClick(row);
                                    setModalMode('edit');
                                }}
                            >
                            </Button>}
                    >
                    </Popup>


                    <Popup
                        content="Obriši"
                        position="top center"
                        trigger={
                            <Button
                                basic="true"
                                color="red"
                                size="small"
                                circular
                                icon="trash alternate"
                                onClick={() => {
                                    handleClick(row);
                                    setModalMode('confirmDelete');
                                }}
                            >
                            </Button>}
                    >
                    </Popup>

                </Fragment>}


        </td> : <td key={index}>{formatForDisplay(row[col.name], col.type)}</td>)}
    </Table.Row>
);

// props: columns ([]), currentEntry ({}), setModalMode (fn)
class LookupSimplerInfo extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        const { currentEntry, columns, setModalMode } = this.props;
        return (
            <Container>
                <Segment.Group raised>
                    <Segment>
                        <PageHeader>Info</PageHeader>
                    </Segment>
                    <Segment>
                        <dl className="dl-horizontal">
                            {columns.map((e, index) =>
                                (<div key={index}>
                                    <dt>{e.simpleName}</dt>
                                    <dd>{formatForDisplay(currentEntry[e.name], e.type)}</dd>
                                </div>))}
                        </dl>
                    </Segment>
                    <Segment>
                        <Button color="green" basic="true" onClick={() => setModalMode('edit')}>Izmijeni</Button>
                        <Button color="red" basic="true" onClick={() => setModalMode('confirmDelete')}>Izbriši</Button>
                        <Button color="blue" basic="true" onClick={() => setModalMode(null)}>Odustani</Button>
                    </Segment>
                </Segment.Group>
            </Container>
        );
    }
}
// props: setModalMode (fn)
class LookupSimplerConfirmDelete extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
        this.handleDeleteEntry = this.handleDeleteEntry.bind(this);
    }

    handleDeleteEntry() {
        const { url, currentEntry } = this.props;
        axios.delete(`${url}/${currentEntry.id}`)
            .then(() => this.props.handleFormSubmit(currentEntry, 'confirmDelete'));
    }

    render() {
        return (
            <Container>
                <h4>Jeste li sigurni?</h4>
                <Button.Group >
                    <Button
                        basic="true"
                        color="red"
                        onClick={() => this.handleDeleteEntry()}
                    > Da </Button>
                    <Button
                        color="blue"
                        basic="true"
                        onClick={() => this.props.setModalMode(null)}
                    >  Ne

                    </Button>
                </Button.Group>
                {/* <Segment.Group> */}
                {/*     <Segment> */}
                {/*         <Header as="h3">Jeste li sigurni?</Header> */}
                {/*     </Segment> */}
                {/*     <Segment> */}
                {/*         <Button */}
                {/*             color="blue" */}
                {/*             onClick={() => this.handleDeleteEntry()} */}

                {/*         >Da */}
                {/*         </Button> */}
                {/*         <Button */}
                {/*             color="blue" */}
                {/*             basic="true" */}
                {/*             onClick={() => this.props.setModalMode(null)} */}
                {/*         >Ne */}
                {/*         </Button> */}
                {/*     </Segment> */}
                {/* </Segment.Group> */}
            </Container>
        );
    }
}

export default LookupSimpler;



// WEBPACK FOOTER //
// ./src/views/Lookups/LookupSimpler.js